import React from 'react'
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Label,
  Input,
  Form,
  FormGroup,
} from "reactstrap"
import timestamper from '../../helpers/timestamper'
import AssignBadge from './AssignBadge'
import SelectAssignmentType from './AssignmentsManage/SelectAssignmentType'
import assignmentTypes from '../../config/assignmentTypes'
import DeleteAssignment from './AssignmentsManage/DeleteAssignment'
import ItemSearchBar from './AssignmentsManage/ItemSearchBar'
import moveUnit from '../../helpers/moveUnit'

const has = require('mout/object/has')

// Main elements:
// Assignment Selector, where you select which assignment you're managing
// Active Assignment, where you add stuff
// Items List, where you find and select stuff to add
// Assigner, where you manage who it is assigned to and any deadlines (for all or for one)
// Analytics, where you see how students are doing on the assignment
// Settings, where you adjust settings like controlling when can use


// On left side, selector, with at the top, a + new assignment, with list of assignments below.
// On right side, interface for editing or creating assignments 

export default function AssignmentsManage (props) {

  const savingActions = {
    isSaving: props.setSavingTrue,
    savingSuccess: props.savingSuccess,
    savingError: props.savingError,
  }

  let itemRows
  if (props.items) {
    itemRows = props.items.map( (item, n) => {
      return ( 
        <tr 
          key={'itemRow' + n} 
          className={item.itemId === props.selectedItem ? 'bg-info' : 'clickable'}
        >
          <td>{item.itemId}</td>
          <td>{item.question}</td>
          <td>{item.name ? item.name : ''}</td>
          <td>{item.code ? item.code : ''}</td>
          <td>
            <Button
              color='secondary'
              onClick={ () => props.selectItem(item.itemId)}
              disabled
            >
              Preview
            </Button>{' '}
            <Button 
              color="primary"
              onClick={ () => props.addUnitToAssignmentAndSave(item, timestamper())}
              disabled={props.assignmentId ? false : true}
            >
              + Add
            </Button>
          </td>
        </tr>
      )
    })
  } else {
    itemRows = <tr></tr>
  }


  const itemsTable = (
    <Table responsive>
      <thead>
        <tr>
          <th>Id</th>
          <th>Preview</th>
          <th>Name</th>
          <th>Code</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {itemRows}
      </tbody>
    </Table>
  )

  const itemsFetching = <div><i className="fa fa-circle-o-notch fa-lg fa-spin mr-1 ml-1"></i></div>

/*
assignment: {
  assignmentId: '',
  assignmentName: '',
  createdDate: 0,
  lastModifiedDate: 0,
  units: [],
  assignmentCreator: '',
}


*/
  let assignmentUnitRows
  if (props.assignmentId) {
    assignmentUnitRows = props.assignment.units.map( (unit, n) => {
      return (
        <tr key={'assignmentUnitRow' + n}>
          <td>
            {n !== 0 
              ? <i
                  onClick={() => moveUnit(props.assignmentId, props.assignment.units, n, true, props.setActiveAssignmentUnits, savingActions)} 
                  className="icon-arrow-up-circle icons font-2xl mt-0 m2clickable">
                </i> 
              : null}
            {n === props.assignment.units.length - 1 
              ? null 
              : <i 
                  className="icon-arrow-down-circle icons font-2xl mt-0 m2clickable"
                  onClick={() => moveUnit(props.assignmentId, props.assignment.units, n, false, props.setActiveAssignmentUnits, savingActions)} 
                >
                </i>}
          </td>
          <td>{unit.itemId}</td>
          <td>{unit.question}</td>
          <td>{unit.name}</td>
          <td>{unit.code}</td>
          <td>            
            <Button 
              color='danger' 
              onClick={ () => props.deleteUnitFromAssignmentAndSave(n)}
            >
              - Delete
            </Button></td>
        </tr>
      )
    })
  } else {
    assignmentUnitRows = <tr></tr>
  }

  let saveSettingsButton
  if (props.assignment) {
    if (props.assignmentNameLocalVal === props.assignment.assignmentName && 
        props.assignmentType === props.assignmentTypeStore ) {
      saveSettingsButton = <Button color='secondary' disabled>Saved</Button>
    } else {
      saveSettingsButton = <Button color='primary' onClick={props.saveSettings} disabled={props.assignmentId ? false : true}>Save Settings</Button>
    }
  } else {
    saveSettingsButton = <Button color='secondary' disabled>Saved</Button>
  }

  let assignmentListOptions
  if (props.assignmentList !== [] && Array.isArray(props.assignmentList)) {
    assignmentListOptions = props.assignmentList.map(({assignmentId, assignmentName}, n) => {
      return <option value={assignmentId} key={'assignment' + n}>{assignmentName}</option>
    })
    const dummy = <option key='dummy' value=''>Select an assignment</option>
    assignmentListOptions.splice(0, 0, dummy)
  } else {
    assignmentListOptions = <option></option>
  }

  const assignmentEdit = (
    <div className='animated fadeIn'>
      <Form>
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label htmlFor="assignmentId">Id</Label>
              <Input type="text" id="assignmentId" value={props.assignmentId ? props.assignment.assignmentId : ''} disabled/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label htmlFor="assignmentName">Assignment Name</Label>
              <Input 
                type="text" 
                id="assignmentName" 
                value={props.assignmentNameLocalVal} 
                onChange={props.handleAssignmentNameValueChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            {saveSettingsButton}
            {' '}
            <DeleteAssignment deleteAssignment={props.deleteAssignment} assignmentId={props.assignmentId}/>
          </Col>
        </Row>
      </Form>

    </div>
  )

  let usersRows = <tr></tr>
  if (props.users) {
    usersRows = props.users.map((user, n) => {
      let userHasAssignment = false
      if (has(user, 'assignments.' + props.assignmentId)) {
        if (user.assignments[props.assignmentId]) {
          userHasAssignment = true
        }
      }
      let rowColor = ''
      if (userHasAssignment) {
        rowColor = 'bg-info'
      }
      return (
        <tr key={'usersRow' + n} className={rowColor}>
          <td>{user.displayName}</td>
          <td>{user.email}</td>
          <td>
            <AssignBadge
              addAssignmentToUser={props.addAssignmentToUser}
              removeAssignmentFromUser={props.removeAssignmentFromUser}
              add={!userHasAssignment}
              assignmentId={props.assignmentId}
              userId={user.uid}
            />
           </td>
        </tr>
      )
    })
  }
  
  const usersTable = (
    <Table>
      <thead>
        <tr>
          <th>User Name</th>
          <th>Email</th>
          <th>Assign</th>
        </tr>
      </thead>
      <tbody>
        {usersRows}
      </tbody>
    </Table>
  )

  return (
  <div className='animated fadeIn'>
    <Row>
      <Col xs='12' lg='12'>
        <Card>
          <CardHeader>
            Assignment Selector
          </CardHeader>
          <CardBody>
            <Label htmlFor='assignmentChoices'>Select an assignment to edit or create a new one.</Label>
            <Form>
              <FormGroup>
                <Row>
                  <Col>
                    <Input 
                      type='select' 
                      name='assignmentChoices' 
                      id='assignmentChoices' 
                      onChange={props.selectAssignment}
                      value={props.assignmentId}
                    >
                      {assignmentListOptions}
                    </Input>
                  </Col>
                  <Col xs='4' sm='3' md='2' lg='2'>
                    <Button 
                      className='mr-1' 
                      color='primary'
                      onClick={(e) => props.createNewAssignment(e)}
                    >
                      New Assignment
                    </Button>
                  </Col>
                </Row>
              </FormGroup>

            </Form>
          </CardBody>
        </Card>
      </Col>
      <Col xs='12' lg='12'>
        <Card>
          <CardHeader>
            Settings
          </CardHeader>
          <CardBody>
            <SelectAssignmentType 
              assignmentType={props.assignmentType} 
              handleChange={props.handleChange}
              assignmentOptions={assignmentTypes}    
            />
            {assignmentEdit}
          </CardBody>
        </Card>
      </Col>
      
      <Col xs='12' lg='12'>
        <Card>
          <CardHeader>
            Assignment: {props.assignment ? props.assignment.assignmentId : ''}
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr>
                  <th></th>
                  <th>Id</th>
                  <th>Preview</th>
                  <th>Name</th>
                  <th>Code</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {assignmentUnitRows}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
      <Col xs='12' lg='12'>
        <Card>
          <CardHeader>
            Items
          </CardHeader>
          <CardBody>
            <ItemSearchBar 
              search={props.search} 
              searchType={props.searchType}
              handleChange={props.handleSearchChange}
              nodes={props.nodes} 
            />
            {props.isFetchingItems ? itemsFetching : itemsTable}
          </CardBody>
        </Card>
      </Col>
      <Col xs='12' lg='12'>
        <Card>
          <CardHeader>
            Assigner
          </CardHeader>
          <CardBody>
            {usersTable}
          </CardBody>
        </Card>
      </Col>
      <Col xs='12' lg='12'>
        <Card>
          <CardHeader>
            Analytics
          </CardHeader>
          <CardBody>
            Info on how students are doing on the active assignment.
          </CardBody>
        </Card>
      </Col>

    </Row>
  </div>
  
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentsManage.js